<template>
  <div>
    <page-header :title="$t('common.offline_export')" />
    <page-body>
      <offline-export-list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import OfflineExportList from './components/List'

export default {
  name: 'OfflineExportIndex',
  components: {
    OfflineExportList,
  },
  data () {
    return {
      listId: 'OfflineExportList',
    }
  },
  methods: {
  },
}
</script>
